import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
}));
